import * as React from "react"

import { cn } from "@/lib/utils"

const focusClasses = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
const disabledClasses = "disabled:cursor-not-allowed disabled:opacity-50"
const errorClasses = "data-[show-error]:aria-[invalid=true]:border-destructive data-[show-error]:aria-[invalid=true]:ring-destructive"

const Textarea = React.memo(
  React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground md:text-sm",
          focusClasses,
          disabledClasses,
          errorClasses,
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  }),
)
Textarea.displayName = "Textarea"

export { Textarea }
